import React, { Fragment } from 'react'

import { Menu, Transition } from '@headlessui/react'
import { Icon } from '@mundi/design-system'
import { useTranslation } from 'react-i18next'
import { logOut } from 'utils/auth'
import { getInitialsCompanyName } from 'utils/common'

import { useListenLocalStorage } from '../../hooks/localStorage'

const Tooltip: React.FC = () => {
  const { t } = useTranslation()
  const localValues = useListenLocalStorage(['email', 'companyName'])

  return (
    <Menu as="div" className="relative ml-3">
      <div>
        <Menu.Button className="flex items-center justify-center text-sm">
          <span className="sr-only">Open user menu</span>
          <span className="flex items-center justify-center w-8 h-8 text-white bg-gray-800 rounded-full">
            {getInitialsCompanyName(localValues.companyName)}
          </span>
          <Icon className="pl-0.5" icon="chevron-down" />
        </Menu.Button>
      </div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 flex flex-col w-64 py-4 mt-2 origin-top-right bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="flex flex-col px-5 pb-3 border-b">
            <p className="w-full mb-1 overflow-hidden text-sm font-semibold whitespace-nowrap overflow-ellipsis">
              {localValues.companyName}
            </p>
            <p className="overflow-hidden text-xs whitespace-nowrap overflow-ellipsis text-full">
              {localValues.email}
            </p>
          </div>
          <Menu.Item>
            {({ active }) => (
              <button
                className={`
                    ${active && 'bg-gray-50'} 
                    block px-4 py-2 text-xs text-full m-auto mt-6 border border-full rounded
                  `}
                onClick={logOut}
              >
                {t('tooltip.logout')}
              </button>
            )}
          </Menu.Item>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}

export default Tooltip
